import { CalcTarget, DistanceUnit } from '../types';

export interface SharePayload {
  distanceKm: number;
  paceSecsPerKm: number;
  totalSeconds: number;
  calcTarget?: CalcTarget;
  distanceUnit?: DistanceUnit;
}

const inRange = (n: unknown, min: number, max: number): n is number =>
  typeof n === 'number' && Number.isFinite(n) && n >= min && n <= max;

/** Leest en valideert de `?share=`-parameter. Geeft undefined bij alles wat niet klopt. */
export function parseSharePayload(param: string): SharePayload | undefined {
  try {
    const decoded = JSON.parse(decodeURIComponent(atob(param)));
    if (!decoded || typeof decoded !== 'object') return undefined;
    const { distanceKm, paceSecsPerKm, totalSeconds, calcTarget, distanceUnit } = decoded as Record<string, unknown>;
    if (!inRange(distanceKm, 0.01, 1000)) return undefined;
    if (!inRange(paceSecsPerKm, 1, 3600)) return undefined;
    if (!inRange(totalSeconds, 1, 100 * 3600)) return undefined;
    return {
      distanceKm,
      paceSecsPerKm,
      totalSeconds,
      calcTarget: calcTarget === 'time' || calcTarget === 'pace' || calcTarget === 'distance' ? calcTarget : undefined,
      distanceUnit: distanceUnit === 'km' || distanceUnit === 'mi' ? distanceUnit : undefined,
    };
  } catch {
    return undefined;
  }
}
